import { sectionRenderer } from '@theme/section-renderer';
import { morph } from '@theme/morph';

/**
 * The filters drawer duplicates every filter and only mobile visitors open it, so a page
 * load renders it empty (see blocks/filters.liquid). Section Rendering API responses do
 * render it, so fill it from one: after load on mobile, or when anything opens it.
 */

const DRAWER_ID = 'filters-drawer';
const PLACEHOLDER = '[data-drawer-placeholder]';
const mobile = window.matchMedia('(max-width: 749px)');

/** @type {Promise<void> | null} */
let pending = null;

function fillDrawer() {
  const drawer = document.getElementById(DRAWER_ID);
  if (!drawer?.querySelector(PLACEHOLDER)) return;

  const section = drawer.closest('.shopify-section');
  if (!section) return;

  pending ??= sectionRenderer
    .getSectionHTML(section.id, false)
    .then((html) => {
      const dialog = document.getElementById(DRAWER_ID)?.querySelector('dialog');
      if (!dialog?.querySelector(PLACEHOLDER)) return;

      const fresh = new DOMParser().parseFromString(html, 'text/html').getElementById(DRAWER_ID);
      const freshDialog = fresh?.querySelector('dialog');
      if (!freshDialog || freshDialog.querySelector(PLACEHOLDER)) return;

      // Morph the dialog's children only, so an already-open drawer stays open.
      morph(dialog, freshDialog);
    })
    .catch(() => {})
    .finally(() => {
      pending = null;
    });
}

function fillWhenIdle() {
  if (!mobile.matches) return;
  if ('requestIdleCallback' in window) requestIdleCallback(fillDrawer, { timeout: 2000 });
  else setTimeout(fillDrawer, 200);
}

if (document.readyState === 'complete') fillWhenIdle();
else window.addEventListener('load', fillWhenIdle, { once: true });

mobile.addEventListener('change', fillWhenIdle);

document.addEventListener(
  'click',
  (event) => {
    if (event.target instanceof Element && event.target.closest(`[on\\:click="#${DRAWER_ID}/showDialog"]`)) {
      fillDrawer();
    }
  },
  true
);
